import { render, staticRenderFns } from "./RuleSpot.vue?vue&type=template&id=117f2bb4"
import script from "./RuleSpot.vue?vue&type=script&lang=js"
export * from "./RuleSpot.vue?vue&type=script&lang=js"
import style0 from "./RuleSpot.vue?vue&type=style&index=0&id=117f2bb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports